/** @module Camunda/ProcessDefinitionPrimarySubtypeRenderer */
define([
	"dojo/_base/declare",
	"csi/config",
	"csi/heading/RefNoLink"
], function(declare,config,RefNoLink) {

	return declare(RefNoLink, {
		/**
		 * @override
		 * Return subtype store for PrimaryType class
		 */
		getStore: function(ctx, h, value, bAll) {
			return config.getSubtypeStore(ctx.getNode().PrimaryType);
		}
	});
});
